import { ChannelTypeEnum } from "../../types";
import EventBus from "../event-bus";
const logoutHook = new EventBus<{
  channelType: ChannelTypeEnum;
  user_id: string;
  quit_reason: string;
}>("logoutHook");

export default logoutHook;
